import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const ManageInvoicesRaw = React.lazy(() => import(/* webpackChunkName: "AdminManageInvoices" */ './ManageInvoices'));
export const AdminManageInvoices = () => (React.createElement(Page, { title: "Administrator Manage Invoices", description: "MAdministrator Manage Invoices" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(ManageInvoicesRaw, null)))));
